import http,{download} from "../../../utils/HttpUtils";

//供应商账单接口服务
class SupplierBillService {
    //查询供应商列表
    static async loadSupplierList(data){
        const apiUrl = "/bill/supplier/findSummaryPage"
        return await http.post(apiUrl,data)
    };
    //分页查询供应商账单汇总信息
    static async loadBillList(data) {
        const apiUrl = "/bill/supplier/findBillPage";
        return await http.post(apiUrl, data);
    }
    //供应商账单平账
    static async BillFlat(data) {
        const apiUrl = "/bill/supplier/balance";
        return await http.post(apiUrl, data);
    }
    //供应商平账记导出
    static async export(res) {
        const apiUrl = "/bill/supplier/export";
        await download(apiUrl,res)
    }
    //供应商账单平帐记录
    static async loadBalanceList(data) {
        const apiUrl = "/bill/supplier/balance/findRecord";
        return await http.post(apiUrl, data);
    }

    //供应商账单平帐详情
    static async loadBalanceDetail(data) {
        const apiUrl = "/bill/supplier/balance/" + data;
        return await http.get(apiUrl, data);
    }
}
export default SupplierBillService;
